import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Box from "@material-ui/core/Box";
import { BreadcrumbPage } from "../../shared";
import 'bootstrap/dist/css/bootstrap.min.css';
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import Form from 'react-bootstrap/Form'
import FormControl from "@material-ui/core/FormControl";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@mui/material/Checkbox';
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import { postRequest, getRequest, putRequest } from "../../services/ApiServices";
import clsx from "clsx";
import userObj from "./Userdomain";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from '@mui/material/Tooltip';
import {
    FormHelperText,
    Input,
    InputBase,
} from "@material-ui/core";
import { useState } from "react";
import { getCookie } from "../../services/Cookies";
import FormControlLabel from '@mui/material/FormControlLabel';

const useStyles = makeStyles((theme) => ({
    justifyContentBetween: {
        justifyContent: "space-between!important",
    },
    alignItemsStretch: {
        alignItems: "stretch",
    },
    mainBox: {
        width: "95%",
        height: "500px",
        backgroundColor: '#fff',
        marginRight: '2rem',
        marginLeft: '2rem',
        boxShadow: "0px 4px 5px -3px rgba(1,1,1,0.75)",
    },
    form: {
        textAlign: "center",
        width: '60vw',
        height: '60vh',
        position: 'absolute',
        top: "50%",
        left: "50%",
        transform: 'translate(-50%,-50%)',
        marginTop: "5rem !important"


    },
    item: {
        width: "50px",
    },
    anchorTag: {
        textDecoration: "none",
        cursor: "pointer",
    },
    btnStyle2: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "4px 22px",
        marginRight: "8px",
    },
    btnStyle3: {
        color: "#ff4717",
        //boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
        marginLeft: "15px",
        padding: "8px",
        marginLeft: "18px",
        cursor: "pointer",
    },
    btnStyle4: {
        bottom: "400px",
        left: "290px",
    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: "338px",
        "& select": {
            padding: "6px"
        }
    },
}));


export default function Customersetting() {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const BreadcrumbList = [{ name: "Customer Setting", url: "" }];
    const [registeredUsers, setRegisteredUsers] = useState([]);
    const [value, setValue] = useState('');
    const [selectedCustomerKey, setSelectedCustomerKey] = React.useState([]);
    const [customerDetailsBySearch, setCustomerDetailsBySearch] = React.useState([]);
    const [disableGrouping, setdisableGrouping] = useState(false);
    const [HistoricVessels, setHistoricVessels] = useState(true);
    const autoTextCustomer = (event) => {
        debugger
        let searchStr = event.target.value;
        setValue(searchStr);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Customer/${searchStr}`;
        getRequest(url)
            .then((res) => {
                debugger
                console.log("res", res.data);
                if (res.status == 200) {
                    let totalArray = [];
                    res.data.map((item) => {
                        if (item.customerName || item.customerkeys) {
                            totalArray.push(item);
                        }
                    });
                    setCustomerDetailsBySearch(totalArray);
                } else {
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
                ////console.log(error);
                // ToastError(error.response.data.message);
            });
    }

    const getAllUser = () => {
        const url =
            process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
            `SupportTicket/retriveTicket`;
        dispatch({ type: LOADING, payload: true });
        getRequest(url)
            .then((res) => {
                if (res.status == 200) {
                    dispatch({ type: LOADING, payload: false });
                    setRegisteredUsers(res.data);
                    //onDownloadPic(res.data[0].attachmentId);
                } else {
                    dispatch({ type: LOADING, payload: false });
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
                ToastError(error.response.data.message);
                dispatch({ type: LOADING, payload: false });
            });
    }

    useEffect(() => {
        getAllUser();
    }, []);


    const CheckBox = (event,field) => {
        debugger
        console.log('field',field)
        if(field=="disableGrouping"){
            setdisableGrouping(event.target.checked);
        }else{
            setHistoricVessels(event.target.checked);
        }
      
    }

    const customersettingGrouping = async () => {
        debugger
        let data = { CustomerName: value, DisableGrouping: disableGrouping ,HistoricVessels:HistoricVessels};
        console.log('data',data)
        //  var jsonData =JSON.stringify(data);
        if (data.CustomerName == "") {
            ToastError("Please Select the Customer");
        }
        else {

            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Customer/CustomSetting`;
            dispatch({ type: LOADING, payload: true });
            await postRequest(url, data)
                .then((res) => {
                    console.log("res", res);
                    if (res.status == 200) {
                        ToastSuccess("Saved Successfully");
                        dispatch({ type: LOADING, payload: false });
                        history.push("/dashboard/admin");
                    }
                    else {
                        ToastError("unsucessfull");
                        dispatch({ type: LOADING, payload: false });
                    }
                })
                .catch((error) => {
                    ToastError(error.response.data.message);
                    dispatch({ type: LOADING, payload: false });
                });
        }
    }


    return (
        <div>

            <Box pb={3} pt={0} display="dlock">
                <BreadcrumbPage rows={BreadcrumbList} /*icon={<Help onClick={handleClickOpenForm} />}*/ />
            </Box>
            <div className={classes.mainBox}>
                {/* <div>
                        <Box component="div" className="pos_relative">

                            <Dialog
                                open={openform}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title" color="white">Customer Domain</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        //ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p className="subtitle">Help On Customer Domain</p><br />
                                        <img className="maxwidth100" src="/assets/images/Customer_domain_help_section1.jpg"></img><br /><br />
                                        <p>
                                            <li>Type the domain name in search box<img src={Type} alt="" width="150px" height="150px" /> and click the search button<img src={Searchbutton} alt="" width="70px" height="70px" /> will display the particular</li>
                                            <div className={classes.text}>customer name</div><br />
                                            <li>Click the clear button<img src={Clearbutton} alt="" width="70px" height="70px" /> will clear the searched details</li><br />
                                            <li>Click the Add Domain<img src={AddDomain} alt="" width="90px" height="90px" /> will add the new domain name</li><br />
                                            <li>Click the edit, admin can change the Status(Active or Inactive)for a particular customer</li><br />
                                            <li>Click the status will display the domain active or inactive</li>
                                        </p>

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClickClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </div> */}

                <Form className={classes.form}>
                    <Form.Group as={Row} controlId="formHorizontalEmail" className="justify-content-md-center">
                        <Form.Label column sm={2}>
                            Customer Name
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl variant="outlined" name="customerName" className={classes.formControl + " cust-select-1"}>

                                <Autocomplete
                                    id="combo-box-demo"
                                    options={customerDetailsBySearch}
                                    name="contractKeys"
                                    inputValue={value}
                                    onInputChange={(event, newInputValue) => {
                                        ////console.log(newInputValue);

                                    }}
                                    // value={formObj.customerKeys[0]}
                                    onChange={(event, newValue) => {
                                        debugger
                                        ////console.log(newValue, 'newValue...');
                                        if (newValue) {
                                            setValue(newValue.customerName);
                                            setSelectedCustomerKey(newValue.customerKey);
                                            setdisableGrouping(newValue.isgrouping);
                                            setHistoricVessels(newValue.historicVessel);
                                            ////console.log("Selected customerKey:",newValue);

                                        } else {
                                            setValue("");
                                            // setContractDetails([]);
                                            // setFormObj({ ...formObj, ["customerKeys"]:[]})
                                        }
                                    }}
                                    getOptionLabel={(option) => option.customerName}
                                    // style={{ width: 300 }}
                                    renderInput={(params) => <TextField {...params}
                                        onChange={autoTextCustomer}
                                        label="" className={clsx(classes.autoTextbox)} />}
                                />
                            </FormControl>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="justify-content-md-center">
                        <Col sm={2}>

                            <Checkbox
                                checked={disableGrouping}
                                onChange={(event) => CheckBox(event, 'disableGrouping')}
                                //inputProps={{ 'aria-label': 'controlled' }}
                                className={classes.btnStyle3}
                            />

                        </Col>
                        <Form.Label column sm={2}  >
                            Disable Grouping
                        </Form.Label>

                    </Form.Group >

                    <Form.Group as={Row} className="justify-content-md-center">
                        <Col sm={2}>
                          
                            <Checkbox
                                checked={HistoricVessels}
                                onChange={(event) => CheckBox(event, 'HistoricVessels')}
                                //inputProps={{ 'aria-label': 'controlled' }}
                                className={classes.btnStyle3}
                            />

                        </Col>
                        <Form.Label column sm={2}  >
                            Historic Vessel
                        </Form.Label>

                    </Form.Group >
                    <Form.Group as={Row} className="justify-content-md-center">
                        <Col sm={{ span: 4, offset: 2 }}>
                            <Button className={classes.btnStyle2} onClick={customersettingGrouping}>Save</Button>
                            <Button type="button" className={classes.btnStyle2} onClick={() => {
                                history.push("/dashboard/admin");
                            }} >Cancel</Button>
                        </Col>

                    </Form.Group>
                </Form >
            </div >

        </div >
    );
}

